import {
  Breadcrumb,
  Button,
  Card,
  Empty,
  Form,
  Modal,
  Select,
  Tabs,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { accountListSelector } from "../../store/selectors/app.selector";
import ChequeService from "../../services/cheque.service";
import Loader from "../../components/loader";
import { NumericFormat, PatternFormat } from "react-number-format";
import StopCheque from "./stop-cheque";
import { amountFormat } from "../../services/common.service";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../assests/images/bulkpaybreadupload.svg";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function ChequeDetails() {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("ALL");
  const [chequeList, setChequeList] = useState([]);
  const [myChequeList, setMyChequeList] = useState([]);
  const { t } = useTranslation();
  const [accountNo, setAccountNo] = useState("");
  const [form] = Form.useForm();
  const accountList = useSelector(accountListSelector);
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [chequeDetails, setChequeDetails] = useState({});
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    if (location.state) {
      chequeBookChequesStatus(location.state, "");
      setChequeDetails(location.state);
      setAccountNo(location.state.accountNo);
      getChequeDetails(location.state.accountNo);
      form.setFieldsValue({
        accountNo: location.state.accountNo,
        beginCheque: location.state.beginCheque,
      });
    }
  }, []);

  const getChequeDetails = useCallback(async (accountNo) => {
    try {
      const response = await ChequeService.chequeDetails({
        accountNo: accountNo,
      });
      if (response.status === 200) {
        setMyChequeList(response.data["data"] || []);
      }
    } catch (error) {}
  }, []);

  const chequeBookChequesStatus = useCallback(async (details, status) => {
    console.log("details", details);
    try {
      const response = await ChequeService.chequeBookChequesStatus({
        noOfCheques: 20,
        accountNo: details.accountNo,
        beginChqNo: details.beginCheque,
        branchId: details.accountNo.slice(0, 4),
        totalNoOfCheques: details.numberOfLeaves,
        status: status,
      });
      if (response.status === 200) {
        setChequeList(response.data["data"] || []);
      }
    } catch (error) {}
  }, []);

  console.log("checquedetails", chequeList);

  const handleChequeChange = useCallback(
    (beginCheque) => {
      try {
        setActiveKey("ALL");
        setChequeList([]);
        const chequeDetails = myChequeList.find(
          (ele) => ele.beginCheque === beginCheque
        );
        setChequeDetails({ ...chequeDetails, accountNo: accountNo });
        chequeBookChequesStatus({ ...chequeDetails, accountNo: accountNo }, "");
      } catch (error) {}
    },
    [accountNo, myChequeList]
  );

  const handleAccChange = useCallback(async (acctNo) => {
    try {
      setMyChequeList([]);
      setChequeList([]);
      setActiveKey("ALL");
      form.setFieldsValue({
        beginCheque: undefined,
      });
      const response = await ChequeService.chequeDetails({
        accountNo: acctNo,
      });
      if (response.status === 200) {
        setMyChequeList(response.data["data"]);
        if (response.data.length > 0) {
          form.setFieldsValue({
            beginCheque: response.data[0].beginCheque,
          });
          setChequeDetails({ ...response.data["data"][0], accountNo: acctNo });
          chequeBookChequesStatus(
            { ...response.data["data"][0], accountNo: acctNo },
            ""
          );
          setAccountNo(acctNo);
        }
      }
    } catch (error) {}
  }, []);

  const tabChange = useCallback(
    (key) => {
      try {
        setActiveKey(key);
        setChequeList([]);
        chequeBookChequesStatus(chequeDetails, key === "ALL" ? "" : key);
      } catch (error) {}
    },
    [chequeDetails]
  );

  const getStopchequeReasonList = useCallback(async () => {
    try {
      const response = await ChequeService.getStopchequeReasonList();
      if (response.status === 200) {
        setDataSource(response.data["data"] || []);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/cheques")}>My Cheques</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>Cheque Status</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">Cheque Status</h3>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <div className="row">
          <div
            className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3"
            style={{ position: "relative" }}
          >
            <Tabs
              defaultActiveKey="PAYEES"
              type="line"
              onChange={tabChange}
              activeKey={activeKey}
            >
              <Tabs.TabPane tab="All" key="ALL"></Tabs.TabPane>
              <Tabs.TabPane tab="Issued" key="Cleared"></Tabs.TabPane>
              <Tabs.TabPane tab="Unused" key="Pending"></Tabs.TabPane>
              <Tabs.TabPane tab="Stopped" key="Rejected"></Tabs.TabPane>
            </Tabs>
          </div>
          <div className="col-8 cheque-search d-flex justify-content-end">
            <Form layout="inline" form={form}>
              <Form.Item
                label={t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
                name="accountNo"
              >
                <Select
                  style={{ width: 150 }}
                  placeholder={t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                  value={accountNo}
                  onChange={handleAccChange}
                  optionLabelProp={"value"}
                >
                  {accountList.map((option, idx) => (
                    <Select.Option key={idx} value={option.accountNo}>
                      <span className="acc-short-name">
                        {option?.acctShortName}
                      </span>
                      <br />
                      <span style={{ fontSize: "12px" }}>
                        {option?.accountNo}
                      </span>
                      <br />
                      <span style={{ fontSize: "12px" }}>
                        {option?.acctBranchDesc}
                      </span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="Cheque Book" name="beginCheque">
                <Select
                  onChange={handleChequeChange}
                  style={{ width: 125 }}
                  placeholder="Cheque Book"
                >
                  {myChequeList.map((option, idx) => (
                    <Select.Option key={idx} value={option.beginCheque}>
                      {option.beginCheque} -{" "}
                      {parseInt(option.beginCheque) +
                        parseInt(option.numberOfLeaves) -
                        1}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Card>

      <Card className="application-card">
        {chequeList.length === 0 && (
          <Empty description="No cheques available" />
        )}

        <div className="row">
          {chequeList.map((option, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-md-12 col-lg-4">
              <Card className="mb-3 application-card">
                <div className="d-flex justify-content-between align-items-center">
                  <span>Cheque no: {option?.chequeNo}</span>
                  {option.chequeStatus === "Cleared" && (
                    <span>{amountFormat(option?.chequeAmt || "0")}</span>
                  )}
                </div>
                {option?.payeeName && (
                  <p style={{ marginBottom: 3, fontSize: 12 }}>
                    Paid to {option?.payeeName}
                  </p>
                )}

                <p>
                  {option?.bankName && <span>{option?.bankName}</span>}{" "}
                  {option.branchName && <span>, {option.branchName}</span>}
                </p>

                <div className="d-flex justify-content-between align-items-center">
                  <p className={option.chequeStatus}>
                    {option.chequeStatus === "Cleared"
                      ? "Cleared"
                      : option.chequeStatus === "Rejected"
                      ? "Stopped"
                      : option.chequeStatus}
                  </p>

                  {option.chequeStatus === "Pending" && (
                    <span
                      className="Stopped"
                      onClick={() => {
                        setVisible(true);
                        setSelectedDetails({ ...option, accountNo: accountNo });
                        getStopchequeReasonList();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                       {t("navigation.stop_cheque", {
                defaultValue: "Stop Cheque",
              })}
                    </span>
                  )}
                </div>
                {option.chequeStatus === "Rejected" && (
                  <p className="Stopped">Reason : {option.rejectReason}</p>
                )}
              </Card>
            </div>
          ))}
        </div>
      </Card>
      <Modal
        title="Reason to Stop Cheque"
        open={visible}
        footer={null}
        width={550}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <StopCheque
          key={new Date().getTime()}
          setVisible={setVisible}
          selectedDetails={selectedDetails}
          dataSource={dataSource}
          setRefresh={() => {
            setVisible(false);
            setActiveKey("ALL");
            setChequeList([]);
            chequeBookChequesStatus(chequeDetails, "");
          }}
        />
      </Modal>
    </>
  );
}
